import React from 'react';
import DatePicker from 'react-datepicker';
import { de } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import './ReportTitleBar.css';

const ReportTitleBar = ({ data, onChange, onDateChange }) => {
    return (
        <div className="report-title-bar">
            <div className="report-title-left">
                <span className="hashtag-icon">#</span>
                <span>Einsatz Nr.: </span>
                <input type="text" name="nr" value={data.nr} onChange={onChange} className="editable-field" />
                <span className="title-datum">Datum: </span>
                <DatePicker 
                    selected={data.datum} 
                    onChange={onDateChange} 
                    dateFormat="P"
                    className="editable-field"
                    locale={de}
                />
            </div>
            <div className="report-title-right">
                <span>Einsatzleiter</span>
                <input type="text" name="einsatzleiter" value={data.einsatzleiter} onChange={onChange} className="editable-field einsatzleiter-name" />
            </div>
        </div>
    );
};

export default ReportTitleBar; 
